// @flow
import React from "react"
import classnames from "classnames"

type Props = {
  hideBelowModals: boolean,
  onClick: (SyntheticEvent<*>) => void,
}

const SidebarOverlay = ({ onClick, hideBelowModals }: Props) => (
  <div className={classnames("SidebarOverlay", { hideBelowModals })} onClick={onClick} />
)

export default SidebarOverlay
